import React, { useState } from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, Button, Label } from '../../ui'
import { rejectSolicitud } from '../../../lib/supabase'
import { useAuth } from '../../../hooks/useAuth'
import { useUnsavedGuard } from '../../../hooks/useUnsavedGuard'

const RechazarSolicitudModal = ({ open, onOpenChange, solicitud, onSuccess }) => {
  const { staff } = useAuth()
  const guard = useUnsavedGuard({ onClose: () => onOpenChange(false) })
  const [razon, setRazon] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState(null)

  if (!solicitud) return null

  const handleSubmit = async () => {
    if (razon.trim().length < 5) {
      setError('Por favor explica el motivo (min. 5 caracteres)')
      return
    }
    setSubmitting(true)
    setError(null)
    const { error: err } = await rejectSolicitud(solicitud.id, {
      razon: razon.trim(),
      staffId: staff?.id,
    })
    setSubmitting(false)
    if (err) {
      setError(err.message || 'Error al rechazar')
      return
    }
    setRazon('')
    guard.resetDirty()
    onSuccess?.()
  }

  return (
    <Dialog open={open} onOpenChange={guard.onOpenChange}>
      <DialogContent {...guard.dirtyProps} className="max-w-md">
        <DialogHeader>
          <DialogTitle>Rechazar solicitud</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <Label htmlFor="razon">Razon del rechazo (visible para el papa)</Label>
          <textarea
            id="razon"
            value={razon}
            onChange={(e) => setRazon(e.target.value.slice(0, 500))}
            placeholder="Ej. Foto borrosa, monto no coincide, etc."
            className="w-full min-h-[100px] rounded-md border p-2 text-sm"
            maxLength={500}
          />
          <p className="text-[10px] text-muted-foreground text-right">{razon.length}/500</p>
          {error && <p className="text-sm text-red-600">{error}</p>}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => guard.onOpenChange(false)}>Cancelar</Button>
          <Button variant="destructive" onClick={handleSubmit} disabled={submitting}>
            {submitting ? 'Rechazando...' : 'Confirmar rechazo'}
          </Button>
        </DialogFooter>
        {guard.DiscardDialog}
      </DialogContent>
    </Dialog>
  )
}

export default RechazarSolicitudModal
